import { useEffect } from "react";
import PropTypes from "prop-types";
import SignupAuth from "app/pages/SignupPage/Auth/SignupAuth";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchProducts } from "app/pages/Listing/productActionCreators";
import { getProductsForSignupPage } from "app/pages/Listing/productsSelector";
import { getContextualizedSignupPagesPagesAuth } from "app/pages/SignupPage/Auth/SignupAuthActionCreators";
import { getCurrentContextualizedSignupPage } from "app/pages/SignupPage/Auth/SignupAuthSelector";
import { Navigate, useNavigate } from "react-router";
import { signupPageAuthShape } from "app/utils/propTypes";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { getCurrentShop } from "app/reducers/shopSelector";
import { getPartnerCode } from "app/reducers/partnerSelector";

const SignupAuthContainer = props => {
	const {
		fetchProducts,
		getContextualizedSignupPagesPagesAuth,
		signupPageAuth = {},
		isAuthenticated,
		productsVisibility,
		shop,
		partnerCode,
	} = props;
	const navigate = useNavigate();
	const signupPageRedirectUrl = signupPageAuth.redirectUrl;

	useEffect(() => {
		getContextualizedSignupPagesPagesAuth();
	}, []);

	useEffect(() => {
		// Rediriger sur la merch ou la listing si l'utilisateur est déja connecté
		if (isAuthenticated) {
			if (signupPageRedirectUrl) {
				window.location.href = signupPageRedirectUrl;
			} else {
				navigate("/listing");
			}
		} else {
			fetchProducts({ productsVisibility, shop, partnerCode });
		}
	}, [isAuthenticated, signupPageRedirectUrl, productsVisibility, shop, partnerCode]);

	return signupPageAuth ? (
		<SignupAuth {...props} />
	) : (
		<Navigate to={{ pathname: "/not-found" }} />
	);
};

SignupAuthContainer.propTypes = {
	signupPageAuth: signupPageAuthShape,
	fetchProducts: PropTypes.func,
	getContextualizedSignupPagesPagesAuth: PropTypes.func,
	isAuthenticated: PropTypes.bool,
	productsVisibility: PropTypes.string,
	shop: PropTypes.string,
	partnerCode: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		resolution: state.resolution,
		signupPageAuth: getCurrentContextualizedSignupPage(state),
		products: getProductsForSignupPage(state),
		isAuthenticated: isAuthenticated(state),
		shop: getCurrentShop(state),
		partnerCode: getPartnerCode(state),
		productsVisibility: state.productsVisibility,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ fetchProducts, getContextualizedSignupPagesPagesAuth }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SignupAuthContainer);
